

















































import { Component, Ref } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import ModalFooter from '@/components/molecules/ModalFooter'
import {
  defaultInterLibraryLoanCollectionEntryFormBibliographyItem,
  InterLibraryLoanCollectionEntryFormBibliography,
  InterLibraryLoanCollectionEntryFormBibliographyItem
} from '@/components/molecules/InterLibraryLoanCollectionEntryFormBibliography'
import {
  defaultInterLibraryLoanCollectionEntryFormCollectionItem,
  InterLibraryLoanCollectionEntryFormCollection,
  InterLibraryLoanCollectionEntryFormCollectionItem
} from '@/components/molecules/InterLibraryLoanCollectionEntryFormCollection'
import {
  NAV_LOADING_END,
  NAV_LOADING_START,
  PAGE_LOADING_END,
  PAGE_LOADING_START
} from '@/config/event'
import {
  alertStore,
  authUserStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import {
  Alert,
  AlertMessage,
  bibliographyRealApi,
  defaultDefaultParameterInterLibraryLoan,
  defaultParameterApi,
  DefaultParameterInterLibraryLoan,
  ErrorMessage,
  InterlibraryLoanBibliography,
  Keyword,
  separateApi,
  SeparateKeyword
} from '@/api'
import ModalReserve from '@/components/modals/ModalReserve/ModalReserve.vue'
import {
  AlertCodeAL300039,
  Prefix,
  ReceiptPrintName,
  SearchType
} from '@/types'
import dayjs from 'dayjs'
import CODE_KEY from '@/config/code_key'
import { CommandType } from '@/types/websocket'
import { InterLibraryReceipt } from '@/api/models/bibliography-real/InterLibraryReceipt'

export interface ModalInterLibraryLoanCollectionEntryFormInterface {
  isNewRegister: boolean
  bibliographyId?: number
  initialBibliography?: {
    searchType: SearchType
    materialFormat: string
    titleDisplay: string
    authorDisplay: string
    authorKana: string
    publisherDisplay: string
    publisherKana: string
    isbn: string // 登録されている値
    classNo: string
  }
  onRegistered?: () => void
  onReserveClosed?: () => void
}

@Component({
  components: {
    ModalReserve,
    InterLibraryLoanCollectionEntryFormBibliography,
    InterLibraryLoanCollectionEntryFormCollection,
    ModalFooter
  }
})
export default class ModalInterLibraryLoanCollectionEntryForm extends ComponentVue {
  @Ref()
  modalReserve!: ModalReserve

  bibliographyInputItem: InterLibraryLoanCollectionEntryFormBibliographyItem = defaultInterLibraryLoanCollectionEntryFormBibliographyItem()

  collectionInputItem: InterLibraryLoanCollectionEntryFormCollectionItem = defaultInterLibraryLoanCollectionEntryFormCollectionItem()

  registeredCallback?: () => void

  reserveClosedCallback?: () => void

  // ダイアログ閉じたときに初期化しない値を準備
  reserveId: number = 0

  dialog: boolean = false

  isNewRegister: boolean = false

  isRegisterAndReserve: boolean = false

  ndc9: string = ''

  open(params: ModalInterLibraryLoanCollectionEntryFormInterface): void {
    systemCodeStore.fetchAllAndMergeByCodeKeys([CODE_KEY.COLLECTION_MEMO.KEY])
    systemParameterStore.fetchAllAndMergeByCodeKeys([
      CODE_KEY.NUMBER_MANAGEMENT.KEY // 資料番号入力で使用
    ])
    this.isNewRegister = params.isNewRegister

    if (this.isNewRegister) {
      if (params.initialBibliography) {
        this.bibliographyInputItem = {
          id: 0,
          prefix: Prefix.Real,
          searchType: {
            input: params.initialBibliography.searchType,
            errorMessage: ''
          },
          materialFormat: {
            input: params.initialBibliography.materialFormat,
            errorMessage: ''
          },
          titleDisplay: {
            input: params.initialBibliography.titleDisplay,
            errorMessage: ''
          },
          titleKana: {
            input: '',
            errorMessage: ''
          },
          authorDisplay: {
            input: params.initialBibliography.authorDisplay,
            errorMessage: ''
          },
          authorKana: {
            input: params.initialBibliography.authorKana,
            errorMessage: ''
          },
          authorNo: {
            input: '',
            errorMessage: ''
          },
          publisherDisplay: {
            input: params.initialBibliography.publisherDisplay,
            errorMessage: ''
          },
          publisherKana: {
            input: params.initialBibliography.publisherKana,
            errorMessage: ''
          },
          publisherNo: {
            input: '',
            errorMessage: ''
          },
          isbn: {
            input: params.initialBibliography.isbn,
            errorMessage: ''
          },
          etcType: {
            input: '',
            errorMessage: ''
          },
          etcNo: {
            input: '',
            errorMessage: ''
          },
          classNo: {
            input: params.initialBibliography.classNo,
            errorMessage: ''
          }
        }
      }

      this.reserveId = this.bibliographyInputItem.id

      this.getDefaultParameterInterLibraryLoan()
    } else if (params.bibliographyId) {
      this.getInterlibraryLoanBibliography(params.bibliographyId).then(
        this.getDefaultParameterInterLibraryLoan
      )
    }
    this.registeredCallback = params.onRegistered ?? undefined
    this.reserveClosedCallback = params.onRegistered ?? undefined

    this.dialog = true
  }

  close(): void {
    this.dialog = false
    this.bibliographyInputItem = defaultInterLibraryLoanCollectionEntryFormBibliographyItem()
    this.collectionInputItem = defaultInterLibraryLoanCollectionEntryFormCollectionItem()
    this.registeredCallback = undefined
    this.isNewRegister = false
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  async onClickContinuousRegister(): Promise<void> {
    try {
      await this.register()
      this.bibliographyInputItem = defaultInterLibraryLoanCollectionEntryFormBibliographyItem()
      this.collectionInputItem = defaultInterLibraryLoanCollectionEntryFormCollectionItem()

      await this.getDefaultParameterInterLibraryLoan()
    } catch {}
  }

  async onClickRegister(): Promise<void> {
    try {
      this.isRegisterAndReserve = false
      await this.register()
      if (this.registeredCallback) {
        this.registeredCallback()
      }
      this.close()
    } catch {}
  }

  async register(): Promise<void> {
    try {
      if (this.isNewRegister) {
        await this.newRegisterInterLibraryLoanCollection()
      } else {
        await this.registerInterLibraryLoanCollection()
      }
    } catch (error) {
      throw error
    }
  }

  async getInterlibraryLoanBibliography(
    bibliographyRealId: number
  ): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      const response: InterlibraryLoanBibliography = await bibliographyRealApi.getInterLibraryLoanBibliography(
        bibliographyRealId
      )

      this.bibliographyInputItem = {
        id: response.bibliographyId,
        prefix: response.prefix,
        searchType: {
          input: response.searchType.code as SearchType,
          errorMessage: ''
        },
        materialFormat: {
          input: response.materialFormat.code,
          errorMessage: ''
        },
        titleDisplay: {
          input: response.titleDisplay,
          errorMessage: ''
        },
        titleKana: {
          input: response.titleKana,
          errorMessage: ''
        },
        authorDisplay: {
          input: response.authorDisplay,
          errorMessage: ''
        },
        authorKana: {
          input: response.authorKana,
          errorMessage: ''
        },
        authorNo: {
          input: response.authorNo,
          errorMessage: ''
        },
        publisherDisplay: {
          input: response.publisherDisplay,
          errorMessage: ''
        },
        publisherKana: {
          input: response.publisherKana,
          errorMessage: ''
        },
        publisherNo: {
          input: response.publisherNo,
          errorMessage: ''
        },
        isbn: {
          input: response.isbn,
          errorMessage: ''
        },
        etcType: {
          input: response.etcType,
          errorMessage: ''
        },
        etcNo: {
          input: response.etcNo,
          errorMessage: ''
        },
        classNo: {
          input: response.classNo,
          errorMessage: ''
        }
      }

      this.ndc9 = response.ndc9

      this.reserveId = this.bibliographyInputItem.id
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  async getDefaultParameterInterLibraryLoan(): Promise<void> {
    this.$eventBus.emit(NAV_LOADING_START)

    try {
      const response: DefaultParameterInterLibraryLoan =
        (
          await defaultParameterApi.getDefaultParameterInterLibraryLoan({
            configBranchCode: authUserStore.authUser.branchCode.code
          })
        ).find(value => value.defaultFlag) ??
        defaultDefaultParameterInterLibraryLoan()

      if (this.isNewRegister) {
        this.bibliographyInputItem.materialFormat.input =
          response.materialFormatCode.code
      }

      let defaultNdc = ''
      if (this.ndc9 !== '') {
        defaultNdc = this.ndc9
      } else if (this.bibliographyInputItem.classNo.input !== '') {
        defaultNdc = this.bibliographyInputItem.classNo.input
      }

      this.collectionInputItem = {
        collectionNo: {
          input: '',
          errorMessage: ''
        },
        holdingBranchCode: {
          input: response.holdingBranchCode.code,
          errorMessage: ''
        },
        collectionType: {
          input: response.collectionType.code,
          errorMessage: ''
        },
        handlingType: {
          input: '',
          errorMessage: ''
        },
        appendixCode: {
          input: '',
          errorMessage: ''
        },
        interlibraryLoanCode: {
          input: response.interlibraryLoanCode.code,
          errorMessage: ''
        },
        requestAdDate: {
          input: dayjs().format('YYYYMMDD'),
          errorMessage: ''
        },
        borrowingDate: {
          input: response.borrowingDate || dayjs().format('YYYYMMDD'),
          errorMessage: ''
        },
        borrowingDueDate: {
          input: response.borrowingDate
            ? dayjs(response.borrowingDate)
                .add(response.borrowingPeriod, 'd')
                .format('YYYYMMDD')
            : dayjs()
                .add(response.borrowingPeriod, 'd')
                .format('YYYYMMDD'),
          errorMessage: ''
        },
        mark: {
          input: '',
          errorMessage: ''
        },
        ndc: {
          input: defaultNdc,
          errorMessage: ''
        },
        book: {
          input: '',
          errorMessage: ''
        },
        sub: {
          input: '',
          errorMessage: ''
        },
        workMemo: {
          input: '',
          code: '',
          errorMessage: ''
        },
        displayMemo: {
          input: '',
          code: '',
          errorMessage: ''
        },
        localMemo: {
          input: '',
          code: '',
          errorMessage: ''
        }
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(NAV_LOADING_END)
    }
  }

  // 通常登録
  async registerInterLibraryLoanCollection(
    _reserveAssign?: boolean
  ): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const interLibraryReceipt: InterLibraryReceipt = await bibliographyRealApi.registerInterLibraryLoanCollection(
        {
          id: this.bibliographyInputItem.id,
          materialFormat: this.bibliographyInputItem.materialFormat.input,
          titleDisplay: this.bibliographyInputItem.titleDisplay.input,
          titleKana: this.bibliographyInputItem.titleKana.input,
          authorDisplay: this.bibliographyInputItem.authorDisplay.input,
          authorKana: this.bibliographyInputItem.authorKana.input,
          authorNo: this.bibliographyInputItem.authorNo.input,
          publisherDisplay: this.bibliographyInputItem.publisherDisplay.input,
          publisherKana: this.bibliographyInputItem.publisherKana.input,
          publisherNo: this.bibliographyInputItem.publisherNo.input,
          isbn: this.bibliographyInputItem.isbn.input,
          etcType: this.bibliographyInputItem.etcType.input,
          etcNo: this.bibliographyInputItem.etcNo.input,
          classNo: this.bibliographyInputItem.classNo.input,
          collectionNo: this.collectionInputItem.collectionNo.input,
          holdingBranchCode: this.collectionInputItem.holdingBranchCode.input,
          collectionType: this.collectionInputItem.collectionType.input,
          handlingType: this.collectionInputItem.handlingType.input,
          appendixCode: this.collectionInputItem.appendixCode.input,
          interlibraryLoanCode: this.collectionInputItem.interlibraryLoanCode
            .input,
          requestAdDate: this.collectionInputItem.requestAdDate.input,
          borrowingDate: this.collectionInputItem.borrowingDate.input,
          borrowingDueDate: this.collectionInputItem.borrowingDueDate.input,
          mark: this.collectionInputItem.mark.input,
          ndc: this.collectionInputItem.ndc.input,
          book: this.collectionInputItem.book.input,
          sub: this.collectionInputItem.sub.input,
          workMemo: this.collectionInputItem.workMemo.input,
          displayMemo: this.collectionInputItem.displayMemo.input,
          localMemo: this.collectionInputItem.localMemo.input,
          _reserveAssign
        }
      )

      if (interLibraryReceipt.receiptInfoReserve !== undefined) {
        this.$webSocket.sendReceiptPrintMessage({
          command: CommandType.ReceiptPrintReserve,
          name: ReceiptPrintName.ReceiptPrintReserve,
          data: interLibraryReceipt.receiptInfoReserve,
          subject: `利用者番号：${interLibraryReceipt.receiptInfoReserve.user_id}`
        })
      }
      if (interLibraryReceipt.receiptInfoReserveForwarding !== undefined) {
        this.$webSocket.sendReceiptPrintMessage({
          command: CommandType.ReceiptPrintReserveForwarding,
          name: ReceiptPrintName.ReceiptPrintReserveForwarding,
          data: interLibraryReceipt.receiptInfoReserveForwarding,
          subject: `資料番号：${interLibraryReceipt.receiptInfoReserveForwarding.collection_no}`
        })
      }
    } catch (error) {
      if (error instanceof AlertMessage) {
        if (
          error.alerts.length === 1 &&
          error.alerts[0].code === AlertCodeAL300039
        ) {
          alertStore.setItem(error.alerts[0])
          this.$modalAlert.open({
            onOkClick: () => {
              if (this.isRegisterAndReserve) {
                this.registerInterLibraryLoanCollection(true).then(() => {
                  this.modalReserve.open({
                    bibliographies: [
                      {
                        bibliographyRealId: this.reserveId
                      }
                    ],
                    userSearchable: true,
                    reservable: true,
                    onClosed: () => {
                      if (this.reserveClosedCallback) {
                        this.reserveClosedCallback()
                      }
                    }
                  })
                  this.close()
                })
              } else {
                this.registerInterLibraryLoanCollection(true).then(() => {
                  if (this.registeredCallback) {
                    this.registeredCallback()
                  }
                  this.close()
                })
              }
            },
            onCancelClick: () => {
              if (this.isRegisterAndReserve) {
                this.registerInterLibraryLoanCollection(false).then(() => {
                  this.modalReserve.open({
                    bibliographies: [
                      {
                        bibliographyRealId: this.reserveId
                      }
                    ],
                    userSearchable: true,
                    reservable: true,
                    onClosed: () => {
                      if (this.reserveClosedCallback) {
                        this.reserveClosedCallback()
                      }
                    }
                  })
                  this.close()
                })
              } else {
                this.registerInterLibraryLoanCollection(false).then(() => {
                  if (this.registeredCallback) {
                    this.registeredCallback()
                  }
                  this.close()
                })
              }
            }
          })
          throw error
        }

        this.setErrorMessage(error.alerts, {
          materialFormat: this.bibliographyInputItem.materialFormat,
          titleDisplay: this.bibliographyInputItem.titleDisplay,
          titleKana: this.bibliographyInputItem.titleKana,
          authorDisplay: this.bibliographyInputItem.authorDisplay,
          authorKana: this.bibliographyInputItem.authorKana,
          authorNo: this.bibliographyInputItem.authorNo,
          publisherDisplay: this.bibliographyInputItem.publisherDisplay,
          publisherKana: this.bibliographyInputItem.publisherKana,
          publisherNo: this.bibliographyInputItem.publisherNo,
          isbn: this.bibliographyInputItem.isbn,
          etcType: this.bibliographyInputItem.etcType,
          etcNo: this.bibliographyInputItem.etcNo,
          classNo: this.bibliographyInputItem.classNo,
          collectionNo: this.collectionInputItem.collectionNo,
          holdingBranchCode: this.collectionInputItem.holdingBranchCode,
          collectionType: this.collectionInputItem.collectionType,
          handlingType: this.collectionInputItem.handlingType,
          appendixCode: this.collectionInputItem.appendixCode,
          interlibraryLoanCode: this.collectionInputItem.interlibraryLoanCode,
          requestAdDate: this.collectionInputItem.requestAdDate,
          borrowingDate: this.collectionInputItem.borrowingDate,
          borrowingDueDate: this.collectionInputItem.borrowingDueDate,
          mark: this.collectionInputItem.mark,
          ndc: this.collectionInputItem.ndc,
          book: this.collectionInputItem.book,
          sub: this.collectionInputItem.sub,
          workMemo: this.collectionInputItem.workMemo,
          displayMemo: this.collectionInputItem.displayMemo,
          localMemo: this.collectionInputItem.localMemo
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  // 新規登録
  async newRegisterInterLibraryLoanCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      this.reserveId = await bibliographyRealApi.registerInterLibraryLoanBibliography(
        {
          searchType: this.bibliographyInputItem.searchType.input,
          materialFormat: this.bibliographyInputItem.materialFormat.input,
          titleDisplay: this.bibliographyInputItem.titleDisplay.input,
          titleKana: this.bibliographyInputItem.titleKana.input,
          authorDisplay: this.bibliographyInputItem.authorDisplay.input,
          authorKana: this.bibliographyInputItem.authorKana.input,
          authorNo: this.bibliographyInputItem.authorNo.input,
          publisherDisplay: this.bibliographyInputItem.publisherDisplay.input,
          publisherKana: this.bibliographyInputItem.publisherKana.input,
          publisherNo: this.bibliographyInputItem.publisherNo.input,
          isbn: this.bibliographyInputItem.isbn.input,
          etcType: this.bibliographyInputItem.etcType.input,
          etcNo: this.bibliographyInputItem.etcNo.input,
          classNo: this.bibliographyInputItem.classNo.input,
          collectionNo: this.collectionInputItem.collectionNo.input,
          holdingBranchCode: this.collectionInputItem.holdingBranchCode.input,
          collectionType: this.collectionInputItem.collectionType.input,
          handlingType: this.collectionInputItem.handlingType.input,
          appendixCode: this.collectionInputItem.appendixCode.input,
          interlibraryLoanCode: this.collectionInputItem.interlibraryLoanCode
            .input,
          requestAdDate: this.collectionInputItem.requestAdDate.input,
          borrowingDate: this.collectionInputItem.borrowingDate.input,
          borrowingDueDate: this.collectionInputItem.borrowingDueDate.input,
          mark: this.collectionInputItem.mark.input,
          ndc: this.collectionInputItem.ndc.input,
          book: this.collectionInputItem.book.input,
          sub: this.collectionInputItem.sub.input,
          workMemo: this.collectionInputItem.workMemo.input,
          displayMemo: this.collectionInputItem.displayMemo.input,
          localMemo: this.collectionInputItem.localMemo.input
        }
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, {
          materialFormat: this.bibliographyInputItem.materialFormat,
          titleDisplay: this.bibliographyInputItem.titleDisplay,
          titleKana: this.bibliographyInputItem.titleKana,
          authorDisplay: this.bibliographyInputItem.authorDisplay,
          authorKana: this.bibliographyInputItem.authorKana,
          authorNo: this.bibliographyInputItem.authorNo,
          publisherDisplay: this.bibliographyInputItem.publisherDisplay,
          publisherKana: this.bibliographyInputItem.publisherKana,
          publisherNo: this.bibliographyInputItem.publisherNo,
          isbn: this.bibliographyInputItem.isbn,
          etcType: this.bibliographyInputItem.etcType,
          etcNo: this.bibliographyInputItem.etcNo,
          classNo: this.bibliographyInputItem.classNo,
          collectionNo: this.collectionInputItem.collectionNo,
          holdingBranchCode: this.collectionInputItem.holdingBranchCode,
          collectionType: this.collectionInputItem.collectionType,
          handlingType: this.collectionInputItem.handlingType,
          appendixCode: this.collectionInputItem.appendixCode,
          interlibraryLoanCode: this.collectionInputItem.interlibraryLoanCode,
          requestAdDate: this.collectionInputItem.requestAdDate,
          borrowingDate: this.collectionInputItem.borrowingDate,
          borrowingDueDate: this.collectionInputItem.borrowingDueDate,
          mark: this.collectionInputItem.mark,
          ndc: this.collectionInputItem.ndc,
          book: this.collectionInputItem.book,
          sub: this.collectionInputItem.sub,
          workMemo: this.collectionInputItem.workMemo,
          displayMemo: this.collectionInputItem.displayMemo,
          localMemo: this.collectionInputItem.localMemo
        })
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
      throw error
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  async onClickWriteKana() {
    const keywords: Keyword[] = []

    // タイトル
    if (
      this.bibliographyInputItem.titleDisplay.input !== '' &&
      this.bibliographyInputItem.titleKana.input === ''
    ) {
      keywords.push({
        key: 'titleDisplay',
        tag: 'titleKana',
        word: this.bibliographyInputItem.titleDisplay.input
      })
    }

    // 責任表示
    if (
      this.bibliographyInputItem.authorDisplay.input !== '' &&
      this.bibliographyInputItem.authorKana.input === ''
    ) {
      keywords.push({
        key: 'authorDisplay',
        tag: 'authorKana',
        word: this.bibliographyInputItem.authorDisplay.input
      })
    }

    // 出版者
    if (
      this.bibliographyInputItem.publisherDisplay.input !== '' &&
      this.bibliographyInputItem.publisherKana.input === ''
    ) {
      keywords.push({
        key: 'publisherDisplay',
        tag: 'publisherKana',
        word: this.bibliographyInputItem.publisherDisplay.input
      })
    }

    if (keywords.length === 0) return

    const separateKeywords: SeparateKeyword[] = await separateApi.separateKana({
      keywords
    })

    separateKeywords.forEach(item => {
      if (item.tag === 'titleKana') {
        this.bibliographyInputItem.titleKana.input = item.value
      }
      if (item.tag === 'authorKana') {
        this.bibliographyInputItem.authorKana.input = item.value
      }
      if (item.tag === 'publisherKana') {
        this.bibliographyInputItem.publisherKana.input = item.value
      }
    })
  }
}
